<template>
  <div class="content-carry">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <p class="c-title">内容搬运</p>
      <div class="content">
        <div class="operating-instructions">
          <div class="operating-instructions-left">
            操作说明:
          </div>
          <div class="operating-instructions-right">
            <p>1、请先阅读并同意内容搬运协议。</p>
            <p>2、前往需要搬运的平台复制个人主页/单个作品链接，平台如：抖音、快手等。</p>
            <p>3、如需批量搬运平台作品，则复制个人主页链接填写在下方进行认证。</p>
            <p>4、如需单个搬运作品，则复制单个作品链接填写在下方。</p>
            <p>5、点击开始搬运，将开始搬运您指定平台作品，单次搬运将持续10-15分钟，请稍后查看结果，勿重复点击。</p>
            <p>6、如果搬运后您发现结果过少，可点击搬运按钮再次搬运，已搬运的视频不会重复搬运。</p>
            <p>7、搬运视频的获取率一般在 50%-90% 左右，如果多次搬运后您发现仍有视频漏搬，烦请手工复制。</p>
          </div>
        </div>
        <div class="operating-instructions">
          <div class="operating-instructions-left">
            选择搬运平台:
          </div>
          <div class="carry-platform-right">
            <el-radio-group  v-model="selectedPlatForm" @change="changePlatForm">
              <el-radio v-for="item in platforms" v-bind:key="item.id" :label="item.code">{{ item.desc }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="certification-errorStatus" v-if="[3, 4].includes(certificationedMedia.auditStatus)">
          {{ certificationedMedia.auditStatus == 3 ? '账号驳回原因: ' : '账号冻结原因: ' }} {{ certificationedMedia.remark || '' }}</div>
        <!-- 主页作品搬运 -->
        <div class="operating-instructions">
          <div class="operating-instructions-left">
            主页搬运:
          </div>
          <div class="carry-all-right">
            <el-button type="primary" size="small" @click="carry(1)">{{ carryBtnTxt }}</el-button>
          </div>
        </div>
        <!-- 单个作品搬运 -->
        <div class="operating-instructions">
          <div class="operating-instructions-left">
            作品链接:
          </div>
          <div class="carry-one-right">
            <el-input maxlength="500" class="carry-one-right-input" placeholder="请填写作品链接" v-model="oneWorkLink" />
            <el-button size="small" type="primary" @click="carry(2)">{{carryBtnTxt}}</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="cont-wrap">
      <div class="content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="all">
            <span slot="label" class="slot-item">
              <span>全部</span><span>{{ allCount }}</span>
            </span>
            <base-table
              :tableData="tableData"
              @handleClick="TabhandleClick"
            ></base-table>
          </el-tab-pane>
          <el-tab-pane label="已成功" name="passed">
            <span slot="label" class="slot-item">
              <span>搬运成功</span><span>{{ passedCount }}</span>
            </span>
            <base-table
              :tableData="tableData"
              @handleClick="TabhandleClick"
            ></base-table>
          </el-tab-pane>
          <el-tab-pane label="搬运中" name="pending">
            <span slot="label" class="slot-item">
              <span>搬运中</span><span>{{ pendingCount }}</span>
            </span>
            <base-table
              :tableData="tableData"
              @handleClick="TabhandleClick"
            ></base-table>
          </el-tab-pane>
          <el-tab-pane label="搬运失败" name="rejected">
            <span slot="label" class="slot-item">
              <span>搬运失败</span><span>{{ rejectCount }}</span>
            </span>
            <base-table
              :tableData="tableData"
              @handleClick="TabhandleClick"
            ></base-table>
          </el-tab-pane>
        </el-tabs>
        <pagination
          @sizePageChange="paginationChangeProduct"
          :paginationDatas="paginationDataProduct"
        ></pagination>
      </div>
    </div>

    <!-- 协议弹窗 -->
    <modal
      :isShow.sync="isShowAuthModal"
      :title="authoContent.contentName"
      :isShowBtn="[true, true]"
      :btnText="['不同意', '同意']"
      :width="'70%'"
      :height="'600px'"
      :isShowClose="false"
      @clickHandler="authModalClick"
    >
      <div class="dialogCon" v-html="authoContent.contentParagraphs[0].paragraphContent"></div>
    </modal>

    <!-- 认证弹窗 -->
    <modal
      :isShow.sync="isShowCertificationModal"
      title="上传作者主页认证信息"
      :isShowBtn="[false, false]"
      :btnText="[]"
      :width="'40%'"
      :height="'480px'"
      :isShowClose="false"
    >
      <div class="CertificationdialogCon">
        <div class="tips">您好，请上传您在{{ platformName }}平台的相关信息，用于审核，审核将在1-2个工作日后反馈结果，请稍后登录平台查看，搬运按钮显示为“立即搬运”即为审核通过</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" label-position="left">
          <el-form-item label="账号昵称" prop="nickName">
            <el-input maxlength="50" v-model="ruleForm.nickName"></el-input>
          </el-form-item>
          <el-form-item label="个人主页地址" prop="mainUrl">
            <el-input maxlength="200" v-model="ruleForm.mainUrl"></el-input>
          </el-form-item>
          <a href="https://cont.jd.com/pccontent/12023815" target="_blank" class="info">主页地址获取方式 &gt;&gt;</a>
          <el-form-item label="上传证明材料" prop="imageUrl">
            <el-upload
              ref="fileUpload" class="upload-demo" action="/imageUpload.action" :auto-upload="false" :http-request="httpRequest" :on-change='onImgChange' :before-upload="checkFile" accept="image/png, image/jpeg,image/gif,image/jpg,image/bmp,image/heic" :limit="1" :file-list="fileList"
              >
              <div class="up-box">
                <img v-if="ruleForm.imageUrl" :src="imgHost+ruleForm.imageUrl" class="avatar">
                <div class="up-box-iconText" v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="upload-text">上传图片</span>
                </div>
              </div>
            </el-upload>
          </el-form-item>
          <p  class="info2">上传您在该平台的作者主页截图，图片需要为.jpg或.png格式。<a href="https://cont.jd.com/pccontent/12023815" target="_blank" >证明材料获取方式 &gt;&gt;</a></p>

          <div class="certification-btns">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
          </div>
        </el-form>
      </div>
    </modal>

    <!-- vueCropper 剪裁图片实现-->
    <el-dialog class="cropper-dialog" title="图片剪裁" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogCropperVisible" :before-close="closeDialog">
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper ref="cropper" :img="cropperImg" :outputSize="0.8" outputType="jpeg" :info=true :full=true :canScale=true :canMoveBox=true :original=false :autoCrop=true :fixedNumber=[22,15] :centerBox=true :infoTrue=false :fixedBox=false :autoCropWidth=220 :autoCropHeight=150 mode="cover"></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import breadCrumb from "../../../../components/breadCrumb";
  import baseTable from "../../../../components/baseTable";
  import pagination from "../../../../components/pagination";
  import modal from '@/components/modal'
  import { uploadFile } from '@/utils/axios'
  import { mapState } from 'vuex'
  import {queryAuthorizationContent, authorizeUser, isUserAuthorization,queryDictionaries, listMediaCertifications, submitMediaCertification,submitTask,pageTaskRecords,countTaskRecords, retryTask } from '@/api/user.js'
  export default {
    name: "contentCarry",
    components:{
      breadCrumb,
      modal,
      pagination,
      baseTable
    },
    data() {
      return {
        timer: null, // 轮询定时器
        platforms: [], // 平台列表
        certificationedMedia: {}, // 平台授权情况
        selectedPlatForm: '', //选中的平台
        isAuthored: false,  //是否授权
        authoContent: {contentParagraphs: [{paragraphContent: ''}]}, // 协议内容
        isShowAuthModal: false, // 是否显示协议弹窗
        oneWorkLink: '', // 单个作品链接
        isShowCertificationModal: false, // 是否显示认证弹窗
        cropperImg: '', // 要裁切的文件
        fileList: [], // 文件列表
        dialogCropperVisible: false,  // 裁切弹窗
        ruleForm: { // 认证信息
          nickName: '',
          mainUrl: '',
          imageUrl: ''
        },
        rules: {  // 认证规则
          nickName: [
            { required: true, message: '请输入账号昵称', trigger: 'blur' }
          ],
          mainUrl: [
            { required: true, message: '请输入个人主页地址', trigger: 'blur' }
          ],
          imageUrl: [
            { required: true, message: '上传您在该平台的作者主页截图', trigger: 'blur' }
          ],
        },
        activeName: 'all', // 当前选中的tab
        tableData: {  // tab数据
          tableList: [],
          tableHeader: [
            {
              label: '文章ID',
              prop: 'contentId',
              tableStatus:'contentId'
            },
            {
              label: '第三方平台作品名称',
              prop: 'externalContentName',
              tableStatus:'externalContentName'
            },
            {
              label: '健康内容平台作品名称',
              prop: 'contentName',
              tableStatus:'contentName'
            },
            {
              label: '作品类型',
              prop: 'contentType',
              tableStatus:'contentType'
            },
            {
              label: '搬运时间',
              prop: 'startTime',
              tableStatus: 'startTime'
            },
            {
              label: '搬运状态',
              prop: 'carryStatus',
              tableStatus: 'carryStatus'
            }
          ],
          tableType: 13
        },
        paginationDataProduct: {  // 分页数据
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
        runStatus: [3], // 任务运行状态 1, "待执行" 2, "执行中" 3, "已完成" 4, "重试中" 5, "取消" 6, "终止"
        runStatusObj: {
          1: '待执行',
          2: "执行中",
          3: "已完成" ,
          4: "重试中" ,
          5: "取消" ,
          6: "终止"
        },
        resultStatus: '', // 任务结果状态，1成功，0失败
        allCount: 0, // 全部数量
        passedCount: 0, // 已完成数量
        rejectCount:0, // 失败数量
        pendingCount:0, //搬运中数量
      }
    },
    created() {
      this.isUserAuthorizationed();
    },
    methods: {
      // 查询是否有搬运中的任务
      getIsPendingTask() {
        pageTaskRecords({
          tenantId: this.$commonJs.getTenantId(),
          runStatus: [1,2],
          types: [1,2],
          pageNo: 1,
          pageSize: 1
        }).then(res => {
          clearInterval(this.timer);
          if(res.totalCount > 0) {
            this.timer = setInterval(() => {
              this.getIsPendingTask();
            }, 30000);
          }
          this.queryPlatFormList();
          this.getCarryList();
          this.getCountTaskRecords();
        }).catch(err => {
          clearInterval(this.timer);
          this.$message.error(err.msg || '网络异常，请稍后重试');
        })
      },
      // 用户是否授权
      isUserAuthorizationed() {
        isUserAuthorization({
          tenantId: this.$commonJs.getTenantId(),
          dicCode: '1'
        }).then(res => {
          console.log("🚀 ~ file: contentCarry.vue:56 ~ isUserAuthorizationed ~ res:", res)
          // if (res.code === '0000' && res.success === true) {
            this.isAuthored = res.data;

            // 如果没有授权，则需要显示授权弹窗
            if (res.data === false) {
              this.queryAuthoCon()
            } else {
              this.getIsPendingTask();
              // 已授权，则请求平台列表，分页查询任务列表
              // this.queryPlatFormList();
              // this.getCarryList();
              // this.getCountTaskRecords();
            }
          // } else {
          //   this.$message.error(res.msg);
          // }
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      // 获取授权协议
      queryAuthoCon() {
        queryAuthorizationContent({
          tenantId: this.$commonJs.getTenantId(),
          dicCode: '1',
        }).then(res => {
          console.log("🚀 ~ file: contentCarry.vue:134 ~ queryAuthoCon ~ res:", res)
          if (res.contentId) {
            this.authoContent = res;
            this.isShowAuthModal = true;
          } else {
            this.$message.error(res.msg);
            this.isShowAuthModal = false;
          }
        }).catch(err => {
          this.$message.error(err.msg);
          this.isShowAuthModal = false;
        })
      },
      // 用户协议弹窗按钮点击事件
      authModalClick(val) {
        if (val === 'one') {
          // 不同意授权，返回首页
          this.isShowAuthModal = false;
          this.$router.push('/');
        } else if (val === 'two') {
          // 同意授权
          authorizeUser({
            tenantId: this.$commonJs.getTenantId(),
            dicCode: '1',
          })
          .then(res => {
            console.log("🚀 ~ file: contentCarry.vue:170 ~ authModalClick ~ res:", res)
              this.$message.success('授权成功!');
              this.isShowAuthModal = false;
              this.getIsPendingTask();
              // this.queryPlatFormList();
              // this.getCarryList();
              // this.getCountTaskRecords();
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
        }
      },
      // 查询平台列表
      queryPlatFormList() {
        queryDictionaries({
          tenantId: this.$commonJs.getTenantId(),
          typeList: [53],
        }).then(res => {
          console.log("🚀 ~ file: contentCarry.vue:184 ~ queryPlatFormList ~ res:", res)
          this.platforms = res || [];
          const defaultFirst = res?.[0]?.code || '';
          this.selectedPlatForm = defaultFirst;
          this.queryMediaCertifications(defaultFirst);
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      // 查询创作者认证
      queryMediaCertifications(val) {
        listMediaCertifications({
          tenantId: this.$commonJs.getTenantId(),
          codes: [val],
        }).then(res => {
          console.log("🚀 ~ file: contentCarry.vue:205 ~ queryMediaCertifications ~ res:", res)
          this.certificationedMedia = res[0] || {};
        }).catch(e => {
            this.$message.error(e.msg);
          })
      },
      // 切换平台
      changePlatForm(val) {
        console.log("🚀 ~ file: contentCarry.vue:198 ~ changePlatForm ~ val:", val)
        this.selectedPlatForm = val;
        this.oneWorkLink = '';
        // 查询该平台的认证状态
        this.queryMediaCertifications(val);
      },
      // 分页查询任务列表
      getCarryList() {
        let params = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: this.paginationDataProduct.currentPage,
          pageSize: this.paginationDataProduct.pageSize,
          types:[2,3]
        }
        if (this.resultStatus !== '') {
          params.resultStatus = this.resultStatus;
        }
        if (this.runStatus !== '') {
          params.runStatus = this.runStatus;
        }
        pageTaskRecords(params).then(res => {
          console.log("🚀 ~ file: contentCarry.vue:404 ~ pageTaskRecords ~ res:", res);
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map(item => {
            // 搬运状态
            item.carryStatus = this.runStatusObj[item.resultStatus];
            this.tableData.tableList.push(item)
          })
          this.paginationDataProduct.total = res.totalCount
          this.paginationDataProduct.currentPage = res.pageNo
          this.paginationDataProduct.pageSize = res.pageSize
        }).catch(e => {
            this.$message.error(e.msg);
          })
      },
      // 查询任务列表数量
      getCountTaskRecords() {
        let params = {
          tenantId: this.$commonJs.getTenantId(),
          types:[2,3]
        }
        if (this.resultStatus !== '') {
          params.resultStatus = this.resultStatus;
        }
        if (this.runStatus !== '') {
          params.runStatus = this.runStatus;
        }
        countTaskRecords(params).then(res => {
          if (res && res.length) {
            res.forEach((item) => {
              if (item.key === 'ALL_COUNT') {
                this.allCount = item.count;
              } else if (item.key === 'RUNNING_COUNT') {
                this.pendingCount = item.count;
              } else if (item.key === 'SUCCESS_COUNT') {
                this.passedCount = item.count;
              } else if (item.key === 'FAIL_COUNT') {
                this.rejectCount = item.count;
              }
            })
          }
        }).catch(e => {
            this.$message.error(e.msg);
          })
      },
      // 搬运
      carry(type) {
        if (this.certificationedMedia.auditStatus === 1) {
          this.$message.warning('认证审核中，审核通过即可搬运');
        } else if (this.certificationedMedia.auditStatus === 3) {
          // this.$message.error(this.certificationedMedia?.remark || '账号驳回');
          this.isShowCertificationModal = true;
        } else if (this.certificationedMedia.auditStatus === 4) {
          this.$message.error(this.certificationedMedia?.remark || '账号冻结');
        } else if (this.certificationedMedia.auditStatus === 2) {
          let params = {
            tenantId: this.$commonJs.getTenantId(),
            type,
            taskParam: {sourceType: this.selectedPlatForm}
          }
          // 搬运主页
          if (type == 2) {
            params.taskParam.url = this.oneWorkLink;
          }
          submitTask(params).then(res => {
            console.log("🚀 ~ file: contentCarry.vue:255 ~ carry ~ res:", type, res)
            if (res) {
              this.$message.success('提交成功，请等待10-15分钟后查看搬运结果');
              setTimeout(() => {
                this.getIsPendingTask();
                this.oneWorkLink = '';
              }, 1000);
            }
          }).catch((e) => {
            this.$message.error(e.msg);
          })
        } else {
          // 立即认证
          this.isShowCertificationModal = true;
        }
      },
      onImgChange(file, fileList) {
        if (!file.url) {
          var baseData;
          var reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = () => {
            baseData = reader.result;
            console.log("🚀 ~ file: contentCarry.vue:408 ~ onImgChange ~ baseData:", baseData)
            this.cropperImg = baseData
            this.dialogCropperVisible = true
          }
          return;
        }

        this.cropperImg = file.url
        this.dialogCropperVisible = true
      },
      checkFile(file) {
        const isJPG = /image\/(jpeg|png)/.test(file.type)
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
          this.$message.error('上传图片只能是jpg、png格式！');
        }
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        let data = window.URL.createObjectURL(new Blob([file]))

        return isJPG && isLt5M;
      },
      httpRequest(request) {
        let file = this.file;
        console.log("🚀 ~ file: contentCarry.vue:433 ~ httpRequest ~ file:", file)
        this.uploadFile(file, (msg) => {
          this.ruleForm.imageUrl = msg;
        });

      },
      uploadFile(file, callback) {
        uploadFile(file, event => {
            let percent = parseInt((event.loaded / event.total) * 100 + "");
            if (percent > 99) {
              percent = 99;
            }
            file.progress = percent;
            file.status = "pending";
            // this.setStoragePropertyByName(storageProperty, uploadImageList);
          })
          .then(res => {
            const id = res.data[0]["id"];
            if (id === "1") {
              const url = res.data[0]["msg"];
              callback && callback(url);
              file.status = "resolve"; // 是否上传成功，根据是否有url来判断
            } else if (id === "0") {
              this.$message.error('图片上传失败');
            }
            this.fileList = [];
          })
          .catch(error => {
            file.status = "reject";
            this.fileList = [];
            this.$message.error('图片上传失败');
          });
      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish() {
        this.dialogCropperVisible = false;
        this.$refs.cropper.getCropBlob((data) => {
          console.log("🚀 ~ file: contentCarry.vue:469 ~ this.$refs.cropper.getCropBlob ~ data:", data)
          this.file = data;
          this.$refs.fileUpload.submit();
        })
      },
      cancel() {
        this.dialogCropperVisible = false;
        // this.imgUrl='';
        this.fileList = [];
      },
      // 提交认证信息
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          console.log("🚀 ~ file: contentCarry.vue:493 ~ CertModalClick ~ val:", formName, valid);
          if (valid) {
            submitMediaCertification({
              tenantId: this.$commonJs.getTenantId(),
              dicCode: this.selectedPlatForm,
              mediaNickName: this.ruleForm.nickName,
              homePageUrl: this.ruleForm.mainUrl,
              certificationImg: this.ruleForm.imageUrl
            }).then(res => {
              console.log("🚀 ~ file: contentCarry.vue:509 ~ CertModalClick ~ res:", res)
              if (res.id) {
                this.$message.success('提交成功');
                this.isShowCertificationModal = false;
                this.ruleForm = {
                  nickName: '',
                  mainUrl: '',
                  imageUrl: ''
                };
                // 重新加载页面
                this.queryPlatFormList();
                this.getCarryList()
                this.getCountTaskRecords();
                this.homePageUrl = '';
                this.mediaNickName = '';
                this.certificationImg = '';
              }
            }).catch(e => {
              this.$message.error(e.msg);
            })
          } else {
            return false;
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.isShowCertificationModal = false;
      },
      // 切换tab
      handleClick(tab, event) {
        console.log("🚀 ~ file: contentCarry.vue:497 ~ handleClick ~ tab, event:", this.activeName )
        this.paginationDataProduct = {
          total: 0,
          currentPage: 1,
          pageSize: 10
        }
        if (this.activeName === 'all') {
          // 全部
          this.resultStatus = '';
          this.runStatus = [2,3];
        } else if (this.activeName === 'pending') {
          // 搬运中
          this.resultStatus = '';
          this.runStatus = [2];
        } else if (this.activeName === 'passed') {
          // 已成功
          this.resultStatus = 1;
          this.runStatus = [3];
        } else if (this.activeName === 'rejected') {
          // 搬运失败
          this.resultStatus = 0;
          this.runStatus = [3];
        }

        this.getCarryList();
        this.getCountTaskRecords();
      },
      // 切换页码
      paginationChangeProduct(val) {
        this.paginationDataProduct = val;
        this.getCarryList();
        this.getCountTaskRecords();
      },
      TabhandleClick(val) {
        console.log("🚀 ~ file: contentCarry.vue:616 ~ TabhandleClick ~ val:", val)
        if (val.type === 'preview') {
          // 预览
          if (val?.val?.taskRecordResult?.contentBizDTO?.contentId){
            window.open('https://cont-yf.jd.com/content/'+val?.val?.taskRecordResult?.contentBizDTO?.contentId, '_blank');
          } else {
            this.$message.error('地址有误');
          }
        } else if (val.type === 'recarry') {
          // 重新搬运
          retryTask({
            tenantId: this.$commonJs.getTenantId(),
            id: val.val.id,
          }).then(res => {
            console.log("🚀 ~ file: contentCarry.vue:612 ~ TabhandleClick ~ res:", res)
            if (res) {
              this.$message.success('提交成功');
              setTimeout(() => {
                this.getCarryList();
                this.getCountTaskRecords();
              }, 1000);
            }
          }).catch(e => {
            this.$message.error(e.msg);
          })
        }
      }
    },
    computed: {
      ...mapState([
        'imgHost',
      ]),
      // 搬运按钮
      carryBtnTxt() {
        const certi = this.certificationedMedia;
        console.log("🚀 ~ file: contentCarry.vue:244 ~ carryBtnTxt ~ certificationedMedia:", certi)
        if (certi.auditStatus === 1) {
          return '审核中';
        } else if(certi.auditStatus === 2) {
          return '立即搬运';
        } else if (certi.auditStatus === 3) {
          return '立即认证';
        } else if (certi.auditStatus === 4) {
          return '账号冻结';
        } else {
          return '立即认证';
        }
      },
      // 平台名称
      platformName() {
        const that = this;
        const str = that.platforms.find(n => n.code == that.selectedPlatForm);
        if (str) {
          return str.desc;
        } else {
          return '';
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.content-carry{
  // padding: 30px;
  .wrap{
    padding: 22px 30px;
    width: 100%;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 20px;
    .content{
      padding-top: 20px;
      font-size: 14px;
      .operating-instructions{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .operating-instructions-left{
          width: 100px;
        }
        .carry-one-right{
          display: flex;
          .carry-one-right-input{
            min-width: 700px;
            max-width: calc(100% - 200px);;
            margin-right: 10px;
          }
        }
      }

    }
  }
  .cont-wrap {
    padding: 20px 10px;
    border-radius: 8px;
    background: #fff;
  }
  .cropper-dialog {
    .el-dialog {
      width: 450px;
    }
    .cropper-content {
      width: 100%;
      padding: 20px;
      .cropper {
        width: 100%;
        height: 288px;
      }
    }
  }
}
.dialogCon{
  color: #5f5f6b;
  font-size: 16px;
  padding: 10px 20px;
  text-align: left;
}
.CertificationdialogCon{
  color: #5f5f6b;
  font-size: 16px;
  padding: 10px 50px;
  .up-box{
    width: 100px;
    height: 100px;
    border: 1px blue solid;
    overflow: hidden;
    border-radius: 8px;
    img {
      width: 100px;
      height: 100px;
    }
    .up-box-iconText{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 30px;
    }
  }
  .tips{
    margin-bottom: 20px;
  }
  .info{
    cursor: pointer;
    margin-top: -10px;
    margin-left: 110px;
    font-size: 12px;
    color:blue;
  }
  .info2{
    margin-top: -10px;
    margin-left: 110px;
    font-size: 12px;
    a{
      cursor: pointer;
      color:blue;
    }
  }
  .certification-btns{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
}
.certification-errorStatus{
  color: red;
  margin: 20px 0;
}
</style>
